import React from 'react'

export interface DialogContentProps {
  children: React.ReactNode
  className?: string
  'data-testid'?: string
}

export const DialogContent: React.FC<DialogContentProps> = ({
  children,
  className = '',
  'data-testid': testId,
}) => {
  return (
    <div className={`overflow-auto ${className}`} data-testid={testId}>
      {children}
    </div>
  )
}

export interface DialogActionsProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  'data-testid'?: string
}

export const DialogActions: React.FC<DialogActionsProps> = ({
  children,
  className = '',
  style,
  'data-testid': testId,
}) => {
  return (
    <div
      className={`flex items-center justify-end gap-2 ${className}`}
      style={style}
      data-testid={testId}
    >
      {children}
    </div>
  )
}

export interface DialogTitleProps {
  children: React.ReactNode
  className?: string
  id?: string
  'data-testid'?: string
}

export const DialogTitle: React.FC<DialogTitleProps> = ({
  children,
  className = '',
  id,
  'data-testid': testId,
}) => {
  return (
    <div className={`text-lg font-semibold ${className}`} id={id} data-testid={testId}>
      {children}
    </div>
  )
}
